export enum TrackingRetentionType {
    NEW_CONTRACT = 'newcontract',
    NEW_OPTION = 'newoption'
}

export enum TrackingProductLine {
    P1 = '1P - Internet'
}

export enum TrackingCustomerFootprint {
    UM = 'unitymedia',
    VKD = 'kabel deutschland'
}

export enum TrackingBusinessTransactionType {
    UM = 'cable um>internet & phone',
    VKD = 'cable>internet & phone'
}

export enum TrackingFlowType {
    UM = 'internet_telefon_flow_um',
    VKD = 'internet_telefon_flow'
}
